import { AbstractPmsApiService } from "./abstract.service";
import { User } from "../models";

export class AuthUserPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/auth/user';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @param {...*} params
     * @return {User}
     * @protected
     */
    newModel(attributes, ...params) {

        return new User(attributes);
    }

    /**
     * @return {Promise.<User>}
     */
    get() {

        const url = this.url();

        return this.http
                   .get(url, {headers: this.authHeaders})
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {User} user
     * @return {Promise.<true>}
     */
    update(user) {

        const url = this.url();

        return this.http
                   .put(url, user, {headers: this.authHeaders})
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/auth-user.service.js